import 'bootstrap/dist/css/bootstrap.css';
import 'typeface-roboto'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from "@auth0/auth0-react";
import { useParams } from "react-router-dom";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);


//unprotected URLs
if (document.location.pathname.indexOf('/pireport/') >= 0) {
  root.render(
    <BrowserRouter basename={baseUrl}>
      <App />
      {/* <Auth0Provider
        domain="dev-kc5wehz668pnwt47.us.auth0.com"
        clientId="U0LI0f3x3IUSA63owjII3UpEYE0Pp0C1"
        audience='https://piaapplication.azurewebsites.net/'
        cacheLocation="localstorage"
        redirectUri={window.location.origin}
      >
        <App />
      </Auth0Provider> */}
    </BrowserRouter>);
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.unregister();

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
} else {
  root.render(

    <BrowserRouter basename={baseUrl}>
      <Auth0Provider
        domain="dev-kc5wehz668pnwt47.us.auth0.com"
        clientId="U0LI0f3x3IUSA63owjII3UpEYE0Pp0C1"
        audience='https://piaapplication.azurewebsites.net/'
        cacheLocation="localstorage"
        redirectUri={window.location.origin}
      >
        <App />
      </Auth0Provider>
    </BrowserRouter>);
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.unregister();

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
